import { RefObject, useEffect, useState } from 'react';

/**
 * Custom hook to track the height of a referenced element using ResizeObserver.
 */
const useResizeObserver = (ref: RefObject<HTMLElement>): number => {
  const [height, setHeight] = useState(0);

  useEffect(() => {
    if (!ref.current) return;

    const observer = new ResizeObserver(([entry]) => {
      if (!entry.contentRect) return;

      setHeight(entry.contentRect.height);
    });

    observer.observe(ref.current);

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return height;
};

export default useResizeObserver;
